// A2 (mockups g03, g04, owner-approved 2026-10-27): the app on its old workers.dev address, once it
// lives at its own. A phone here re-joins at the new address: a grown-up with the family's
// recovery code (made here first if they have none), a child with a link code from a grown-up.
// Nothing is lost: the family's progress is on the server.
import { useEffect, useState } from 'react'
import { openOverlay } from '../app/router'
import { useSession } from '../data/session'
import { t } from '../strings/en'
import { ToyBox } from './Welcome'

/** Where the app has moved to, when this host is its old one (GET /api/health), else null. */
export function useMoved(): string | null {
  const [to, setTo] = useState<string | null>(null)
  useEffect(() => {
    void fetch('/api/health')
      .then((r) => (r.ok ? (r.json() as Promise<{ moveTo?: string }>) : null))
      .then((h) => setTo(h?.moveTo ?? null))
      .catch(() => undefined)
  }, [])
  return to
}

export function Moved({ to }: { to: string }) {
  const person = useSession((s) => s.person)
  const child = person?.kind === 'child'
  const host = new URL(to).host
  return (
    <main className="screen who welcome moved">
      <ToyBox />
      <h1 className="h1 who-title">{t.moved.title}</h1>
      <p className="muted welcome-sub">{child ? t.moved.child : t.moved.grownUp}</p>
      <p className="welcome-code moved-host">{host}</p>
      <div className="welcome-choices">
        <a className="btn y press" href={to}>
          {t.moved.open}
        </a>
        {person?.kind === 'admin' ? (
          <button className="btn w press" onClick={() => openOverlay('recovery')}>
            {t.moved.recovery}
          </button>
        ) : null}
      </div>
      {!child ? <p className="muted welcome-sub moved-then">{t.moved.then}</p> : null}
    </main>
  )
}
